"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateS3PresignedUrlResponse = void 0;
class CreateS3PresignedUrlResponse {
}
exports.CreateS3PresignedUrlResponse = CreateS3PresignedUrlResponse;
//# sourceMappingURL=s3.js.map